import React from 'react';
import Select from 'react-select';
import { Controller, useForm } from 'react-hook-form';
import { capitalize } from '../../helpers/formatters';

const userRoles = [
    {
        label: 'User',
        value: 'user'
    },
    {
        label: 'Admin',
        value: 'admin'
    }
];

export const UserForm = ({ model: user = {}, mode = 'show', onSubmit, onReset }) => {
    const defaultRole = user &&
        user.role && {
            value: user.role,
            label: capitalize(user.role)
        };

    const defaultValues = {
        ...user,
        password: '',
        role: defaultRole
    };

    const {
        formState: { errors },
        handleSubmit,
        register,
        control
    } = useForm({ defaultValues });

    const validations = {
        role: {
            required: 'Role is required.'
        },
        name: {
            required: 'Name is required.',
            minLength: {
                value: 3,
                message: 'Name must be at least 3 characters long.'
            }
        },
        email: {
            required: 'Email is required.',
            minLength: {
                value: 8,
                message: 'Email must be at least 8 characters long.'
            },
            pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: 'Entered email is not valid.'
            }
        },
        password: {
            required: 'Password is required.',
            minLength: {
                value: 6,
                message: 'Password must be at least 6 characters long.'
            }
        }
    };

    const handleBeforeSubmit = (form) => {
        onSubmit({
            ...form,
            role: form.role.value
        });
    };

    return (
        <form className="user-form" onSubmit={handleSubmit(handleBeforeSubmit)} onReset={onReset}>
            <div className="row">
                <div className="col-12 mb-3">
                    <label htmlFor="userRole" className="form-label">
                        Role
                    </label>
                    <Controller
                        name="role"
                        id="userRole"
                        control={control}
                        rules={validations.role}
                        render={({
                            field: { onChange, onBlur, value, name, ref },
                            fieldState: { invalid, isTouched, isDirty, error },
                            formState
                        }) => (
                            <Select
                                isDisabled={mode === 'show'}
                                classNamePrefix="react-select"
                                isSearchable={false}
                                options={userRoles}
                                onChange={onChange}
                                onBlur={onBlur}
                                value={value}
                                name={name}
                                ref={ref}
                            />
                        )}
                    />
                    {errors.role && (
                        <div className="invalid-feedback d-block">{errors.role.message}</div>
                    )}
                </div>
                <div className="col-12 mb-3">
                    <label htmlFor="userName" className="form-label">
                        Name
                    </label>
                    <input
                        {...register('name', validations.name)}
                        type="text"
                        id="productName"
                        autoComplete="nope"
                        readOnly={mode == 'show'}
                        className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                    />
                    {errors.name && (
                        <div className="invalid-feedback d-block">{errors.name.message}</div>
                    )}
                </div>
                <div className="col-12 mb-3">
                    <label htmlFor="userEmail" className="form-label">
                        Email
                    </label>
                    <input
                        {...register('email', validations.email)}
                        type="email"
                        id="userEmail"
                        autoComplete="new-email"
                        readOnly={mode == 'show'}
                        className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                    />
                    {errors.email && (
                        <div className="invalid-feedback d-block">{errors.email.message}</div>
                    )}
                </div>
                {mode !== 'show' && (
                    <div className="col-12 mb-3">
                        <label htmlFor="userPassword" className="form-label">
                            Password
                        </label>
                        <input
                            type="password"
                            id="userPassword"
                            autoComplete="new-password"
                            readOnly={mode == 'show'}
                            className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                            {...register('password', !user || !user.id ? validations.password : {})}
                        />
                        {errors.password && (
                            <div className="invalid-feedback d-block">
                                {errors.password.message}
                            </div>
                        )}
                    </div>
                )}
            </div>
            {mode === 'show' && (
                <div className="d-grid col-sm-6 col-md-4 col-lg-3">
                    <button onClick={onReset} type="button" className="btn btn-outline-secondary">
                        Close
                    </button>
                </div>
            )}
            {mode !== 'show' && (
                <div className="row my-3">
                    <div className="d-grid order-1 order-sm-0 col-sm-6 col-md-4 col-lg-3 mb-3 mb-sm-0">
                        <button className="btn btn-outline-secondary" type="reset">
                            Cancel
                        </button>
                    </div>
                    <div className="d-grid order-0 order-sm-1 col-sm-6 col-md-4 col-lg-3 offset-md-4 offset-lg-6 mb-3 mb-sm-0">
                        <button className="btn btn-primary" type="submit">
                            {capitalize(mode)}
                        </button>
                    </div>
                </div>
            )}
        </form>
    );
};
